var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.filteredListToRender.length > 0
    ? _c(
        "div",
        { staticClass: "col-xs-12 reg-body-mg pl-20 pr-20" },
        [
          _c("permission-access-modal"),
          _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
          _c("registration-details-popup", {
            attrs: {
              permissions: _vm.permissions,
              dataRow: _vm.activeProductRegistration,
              reportFlag: true,
            },
            on: { hidePopup: _vm.hidePopup },
          }),
          _vm._l(_vm.filteredListToRender, function (regObj, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "notification-box row font-properties",
              },
              [
                _c("div", { staticClass: "col-xs-12 p-0 mb-15" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-10 p-0 regupdate-title d-flex align-items-start",
                    },
                    [
                      !_vm.isFromGlobalSearch
                        ? _c(
                            "div",
                            {
                              staticClass: "dropdown",
                              attrs: { id: "trackerActionDots" },
                            },
                            [
                              _vm._m(0, true),
                              _c(
                                "ul",
                                {
                                  staticClass: "dropdown-menu left-actions p-0",
                                },
                                [
                                  regObj.isFlagged &&
                                  _vm.permissions.includes(
                                    "REG_WTCH_REG_UPD_UNFLAG"
                                  ) &&
                                  _vm.selectedMenu !== "archive"
                                    ? _c(
                                        "li",
                                        {
                                          staticClass:
                                            "font-16 text-primary d-flex align-items-center",
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateFlag(
                                                false,
                                                regObj.regUpdateId,
                                                regObj.countryId
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticClass:
                                              "cursor-pointer img-16",
                                            attrs: {
                                              src: "/static/images/icons/flag_icon_active.svg",
                                              alt: "",
                                            },
                                          }),
                                          _c("span", { staticClass: "pl-15" }, [
                                            _vm._v("Flag Update"),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                  !regObj.isFlagged &&
                                  _vm.permissions.includes(
                                    "REG_WTCH_REG_UPD_FLAG"
                                  ) &&
                                  _vm.selectedMenu !== "archive"
                                    ? _c(
                                        "li",
                                        {
                                          staticClass:
                                            "font-16 text-primary d-flex align-items-center",
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateFlag(
                                                true,
                                                regObj.regUpdateId,
                                                regObj.countryId
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticClass:
                                              "cursor-pointer img-16",
                                            attrs: {
                                              src: "/static/images/icons/flag_icon.svg",
                                              alt: "",
                                            },
                                          }),
                                          _c("span", { staticClass: "pl-15" }, [
                                            _vm._v("Flag Update"),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.permissions.includes(
                                    "REG_WTCH_REG_UPD_LINE_ARCHIVE"
                                  ) &&
                                  !["new", "archive"].includes(_vm.selectedMenu)
                                    ? _c(
                                        "li",
                                        {
                                          staticClass:
                                            "font-16 text-primary d-flex align-items-center",
                                          on: {
                                            click: function ($event) {
                                              return _vm.archiveRegulatory(
                                                regObj.regUpdateId,
                                                regObj.countryId
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticClass:
                                              "cursor-pointer img-16",
                                            attrs: {
                                              src: "/static/images/reg-watch/archive_icon.svg",
                                              alt: "",
                                            },
                                          }),
                                          _c("span", { staticClass: "pl-15" }, [
                                            _vm._v("Archive"),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.permissions.includes(
                                    "REG_WTCH_REG_UPD_UNARCHIVE"
                                  ) && _vm.selectedMenu === "archive"
                                    ? _c(
                                        "li",
                                        {
                                          staticClass:
                                            "font-16 text-primary d-flex align-items-center",
                                          on: {
                                            click: function ($event) {
                                              return _vm.unArchiveRegulatory(
                                                regObj.regUpdateId
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticClass:
                                              "cursor-pointer img-16",
                                            attrs: {
                                              src: "/static/images/reg-watch/unarchive_icon.svg",
                                              alt: "",
                                            },
                                          }),
                                          _c("span", { staticClass: "pl-15" }, [
                                            _vm._v("Un-archive"),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c("div", {
                        staticClass: "word-break pl-15 font-medium reg-title",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$options.filters.highlight(
                              regObj.title,
                              _vm.searchRegulatory
                            )
                          ),
                        },
                      }),
                    ]
                  ),
                  _vm.selectedMenu === "new" &&
                  _vm.permissions.includes("REG_WTCH_REG_UPD_CLOSE") &&
                  !_vm.isFromGlobalSearch
                    ? _c("div", { staticClass: "col-xs-2 p-0 text-right" }, [
                        _c("img", {
                          staticClass: "cursor-pointer",
                          attrs: {
                            src: "/static/images/icons/close_icon.svg",
                            alt: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.deleteRegulatoryFromNew(
                                regObj.regUpdateId,
                                regObj.countryId
                              )
                            },
                          },
                        }),
                      ])
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "col-xs-12 reg-content" }, [
                  regObj.effectiveDate
                    ? _c("div", { staticClass: "col-xs-12 p-0 mb-15" }, [
                        _c(
                          "span",
                          { staticClass: "font-medium text-secondary" },
                          [_vm._v("Effective date:")]
                        ),
                        _c("span", { staticClass: "font-300" }, [
                          _vm._v(" " + _vm._s(regObj.effectiveDate) + " "),
                        ]),
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 p-0 mb-10 d-flex align-items-center",
                    },
                    [
                      _c("span", {
                        staticClass: "flag-icon flag-icon-squared",
                        class: _vm.countryFlag(regObj.countryCode),
                      }),
                      _c(
                        "span",
                        { staticClass: "pl-10 font-medium text-secondary" },
                        [_vm._v(_vm._s(regObj.countryName))]
                      ),
                    ]
                  ),
                  regObj.linkList && regObj.linkList.length
                    ? _c("div", { staticClass: "col-xs-12 p-0 pb-5" }, [
                        _c(
                          "ul",
                          { staticClass: "ul-list" },
                          _vm._l(regObj.linkList, function (linkDetail, index) {
                            return _c(
                              "li",
                              { key: index, staticClass: "p-0 word-break" },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: linkDetail["link"],
                                      target: "_blank",
                                    },
                                  },
                                  [_vm._v(_vm._s(linkDetail["label"]))]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                  regObj.publishedDate
                    ? _c("div", { staticClass: "col-xs-12 p-0 mb-25" }, [
                        _c(
                          "span",
                          { staticClass: "font-medium text-secondary" },
                          [_vm._v("Published On:")]
                        ),
                        _c("span", { staticClass: "font-300" }, [
                          _vm._v(" " + _vm._s(regObj.publishedDate) + " "),
                        ]),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "col-xs-12 p-0" }, [
                    _c("div", { staticClass: "d-flex justify-space-between" }, [
                      _c("div", { staticClass: "d-flex" }, [
                        _c("div", { staticClass: "text-primary font-medium" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                regObj.productCount === 0
                                  ? "No registrations"
                                  : `${regObj.productCount} registrations`
                              ) +
                              " affected "
                          ),
                        ]),
                        regObj.productCount
                          ? _c("div", { staticClass: "dropdown pl-5" }, [
                              _vm._m(1, true),
                              _c(
                                "div",
                                {
                                  staticClass: "dropdown-menu reg-affected",
                                  class: {
                                    "display-none": !regObj.productList.length,
                                  },
                                },
                                [
                                  regObj.productList.length > 0
                                    ? _c(
                                        "ul",
                                        {
                                          staticClass: "product-list p-0 mb-0",
                                          attrs: { role: "menu" },
                                        },
                                        _vm._l(
                                          regObj.productList,
                                          function (product, index) {
                                            return _c(
                                              "li",
                                              {
                                                key: index,
                                                staticClass:
                                                  "ft-wt-normal font-16 cursor-pointer text-primary",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.getProductRelatedDetails(
                                                      product.regId
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      product.name &&
                                                        product.name.length > 15
                                                        ? `${product.name.substr(
                                                            0,
                                                            14
                                                          )}...`
                                                        : product.name
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _c(
                        "div",
                        { staticClass: "font-medium learn-more-text" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "cursor-pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.openDescriptionModal(regObj)
                                },
                              },
                            },
                            [_vm._v("Learn more")]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]
            )
          }),
          _c("regwatch-description-modal", {
            attrs: { regWatch: _vm.selectedRegWatch },
          }),
        ],
        2
      )
    : _c(
        "div",
        { staticClass: "col-md-12 col-sm-12 col-xs-12 mt-25 font-properties" },
        [
          _c("div", { staticClass: "col-md-offset-4 col-xs-offset-2" }, [
            _vm._v("No Regulatory Updates Found"),
          ]),
        ]
      )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "menu-btn dropdown-toggle",
        attrs: { type: "button", "data-toggle": "dropdown" },
      },
      [_c("i", { staticClass: "fa fa-ellipsis-v menu-dots" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "menu-btn dropdown-toggle arrow-open",
        attrs: { type: "button", "data-toggle": "dropdown" },
      },
      [_c("img", { attrs: { src: "/static/images/icons/chevron_down.svg" } })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }